import { get, post } from "../api_helper";

const getNewsLetterSubscriptions = async () => {
  const url = "get-news-letter-subscriptions";
  const response = await get(url);
  return response;
};

const saveNewLetterSubscription = async (data) => {
  const url = "save-news-letter-subscription";
  const response = await post(url, data);
  return response;
};

export { getNewsLetterSubscriptions, saveNewLetterSubscription };
